<template>
  <ul class="bx--navigation-items">
    <slot />
  </ul>
</template>
<script>
export default {
  name: 'WaSideMenuItems'
}
</script>